// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TAutomatedEmailPatchSender,
  TAutomatedEmailSaleType,
  TAutomatedEmailUserSettingsResponse,
  TAutomatedEmailUserSettingsUpdatePayload,
} from '~/modules/opportunities/automated-email/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class AutomationStatusModel extends DefaultResource {
  protected endpoint: string = 'automated-email/';

  getPatchSettings(
    patchId: number,
    saleType: TAutomatedEmailSaleType,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TAutomatedEmailUserSettingsResponse> {
    return this.get<TAutomatedEmailUserSettingsResponse>(
      'patch-settings',
      { patch_id: patchId, sale_type: saleType },
      requestConfig
    );
  }

  getPatchUsers(
    patchId: number,
    saleType: TAutomatedEmailSaleType,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TAutomatedEmailPatchSender[]> {
    return this.get<TAutomatedEmailPatchSender[]>(
      'patch-settings/users',
      { patch_id: patchId, sale_type: saleType },
      requestConfig
    );
  }

  updatePatchSettings(
    payload: TAutomatedEmailUserSettingsUpdatePayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TAutomatedEmailUserSettingsResponse> {
    return this.post<TAutomatedEmailUserSettingsResponse>('patch-settings', payload, requestConfig);
  }
}
